import { PsDate } from '../model/PsDate';
import { WorkState } from '../model/WorkState';

export class PsWork {

    _id; // number
    _code; // string
    _name; // string
    _startDate; // PsDate
    _endDate; // PsDate
    _active; // boolean
    _notes; // string
    _contracts; // object[]
    _email_alerts; // string

    constructor(
        id,
        code,
        name,
        startDate,
        endDate,
        active,
        notes,
        contracts,
        _email_alerts
    ) {
        this._id = id;
        this._code = code;
        this._name = name;
        this._startDate = startDate;
        this._endDate = endDate;
        this._active = active;
        this._notes = notes;
        this._contracts = contracts;
        this._email_alerts = _email_alerts;
    }

    static fromAPIConstructionSites(constructionSites) {
        return constructionSites.map((cs) => PsWork.fromAPIConstructionSite(cs));
    }

    static fromAPIConstructionSite(constructionSite) {
        return new this(
            constructionSite.id,
            constructionSite.code,
            constructionSite.name,
            PsDate.fromISOString(constructionSite.start_date),
            constructionSite.end_date ? PsDate.fromISOString(constructionSite.end_date) : undefined,
            constructionSite.construction_state && constructionSite.construction_state.id === WorkState.ACTIVE,
            constructionSite.notes,
            constructionSite.contracts || [],
            constructionSite.email_alerts,
        );
    }

    id() {
        return this._id;
    }

    code() {
        return this._code;
    }

    name() {
        return this._name;
    }

    description() {
        return `${this.code()} - ${this.name()}`;
    }

    startDate() {
        return this._startDate;
    }

    startDateString() {
        return this.startDate().toDateString();
    }

    endDate() {
        return this._endDate;
    }

    endDateString() {
        return this.endDate() ? this.endDate().toDateString() : '';
    }

    isActive() {
        return this._active;
    }

    notes() {
        return this._notes;
    }

    contracts() {
        return this._contracts;
    }

    noticesEmail() {
        return this._email_alerts;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/work/PsWork.js